import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "externalId", "clientId", "connectBtn", "cuitInput", "cuitHidden", "title"]
  static values = {
    patientId: Number,
    hasExistingConnection: Boolean,
    existingExternalId: String
  }

  connect() {
    this.checkInterval = null
    this.setupListeners()
  }

  disconnect() {
    this.clearInterval()
  }

  setupListeners() {
    // Escuchar eventos de input/change en el external_id (disparados por colppy-cuit-check)
    if (this.hasExternalIdTarget) {
      this.externalIdTarget.addEventListener('input', () => this.checkExternalId())
      this.externalIdTarget.addEventListener('change', () => this.checkExternalId())
    }

    // Escuchar eventos del modal de Bootstrap
    if (this.hasModalTarget) {
      this.modalTarget.addEventListener('shown.bs.modal', () => this.handleModalShown())
      this.modalTarget.addEventListener('hidden.bs.modal', () => this.handleModalHidden())
    }

    // Verificar inicialmente
    this.checkExternalId()
  }

  handleModalShown() {
    // Enfocar el input de CUIT cuando se muestra el modal
    if (this.hasCuitInputTarget) {
      this.cuitInputTarget.focus()
    }

    // Si hay una conexión existente, limpiar el external_id para forzar nueva búsqueda
    if (this.hasExistingConnectionValue && this.hasExternalIdTarget) {
      // Guardar el external_id existente pero limpiar el campo para nueva búsqueda
      // El campo se llenará cuando se encuentre un nuevo cliente
      this.externalIdTarget.value = ""
    }

    // Verificar si ya hay un external_id
    this.checkExternalId()

    // Auto-trigger Colppy search if CUIT input has a valid value
    if (this.hasCuitInputTarget) {
      const cuitValue = this.cuitInputTarget.value.replace(/\D/g, '')
      if (cuitValue.length >= 11) {
        this.cuitInputTarget.dispatchEvent(new Event('blur'))
      }
    }

    // Verificar periódicamente cuando el modal está abierto (fallback)
    this.clearInterval()
    this.checkInterval = setInterval(() => this.checkExternalId(), 500)
  }

  handleModalHidden() {
    this.clearInterval()
  }

  checkExternalId() {
    if (!this.hasExternalIdTarget || !this.hasClientIdTarget || !this.hasConnectBtnTarget) {
      return
    }

    // Sync CUIT input value to hidden form field
    if (this.hasCuitInputTarget && this.hasCuitHiddenTarget) {
      this.cuitHiddenTarget.value = this.cuitInputTarget.value
    }

    const externalId = this.externalIdTarget.value
    if (externalId && externalId.trim() !== '') {
      this.clientIdTarget.value = externalId

      // Si hay una conexión existente, verificar si es diferente
      if (this.hasExistingConnectionValue && this.existingExternalIdValue) {
        // Habilitar solo si el nuevo external_id es diferente al existente
        if (externalId.trim() !== this.existingExternalIdValue.trim()) {
          this.connectBtnTarget.disabled = false
          this.connectBtnTarget.textContent = "Reemplazar conexión"
        } else {
          // Es el mismo ID, no tiene sentido reemplazar
          this.connectBtnTarget.disabled = true
          this.connectBtnTarget.textContent = "Ya está conectado con este cliente"
        }
      } else {
        // No hay conexión existente, habilitar normalmente
        this.connectBtnTarget.disabled = false
        this.connectBtnTarget.textContent = "Conectar"
      }
    } else {
      this.connectBtnTarget.disabled = true
      // Restaurar texto original según si hay conexión existente
      if (this.hasExistingConnectionValue) {
        this.connectBtnTarget.textContent = "Reemplazar conexión"
      } else {
        this.connectBtnTarget.textContent = "Conectar"
      }
    }
  }

  clearInterval() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
      this.checkInterval = null
    }
  }
}
